// extracted by mini-css-extract-plugin
export default {"sidecontainer":"SideBar_sidecontainer__otfT2","sideUl":"SideBar_sideUl__KW-sa"};